import { render, staticRenderFns } from "./RegisterAuth0.vue?vue&type=template&id=a3c34318&"
import script from "./RegisterAuth0.vue?vue&type=script&lang=js&"
export * from "./RegisterAuth0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports